import { HttpParams } from '@angular/common/http';
import { ClassProvider } from '@angular/core';

export interface AuthConfigI {
  authUrl: string;
  appUrl: string;
  webAppUrl: string;
  hasHttps: boolean;
}

export enum CookieKey {
  SuperadminAccessToken = 'superadmin_access_token',
  AccessToken = 'access_token',
  AccessTokenExpiresAt = 'access_token_expires_at',
  Company = 'company',
}

export interface HttpApiRequestOptions {
  headers?:
    | (Record<string, string | []> & {
        'x-json-accent'?: 'snake' | 'pascal' | 'camel' | [];
      } & IdentityHeaders)
    | {};
  skipURLBuild?: boolean;

  addToken?: boolean;
  skipCompany?: boolean;
}

export enum IdentityHeader {
  Client = 'x-recruitee-client',
  Env = 'x-recruitee-env',
  RealtimeEvent = 'x-recruitee-realtime-event',
  Startup = 'x-recruitee-startup',
}

export type IdentityHeaders = Partial<Record<IdentityHeader, string>>;

export abstract class HttpRequestData {
  public abstract buildUrl(path: string, requestOptions?: HttpApiRequestOptions): string;
  public provideAuthHeaders(): { Authorization: string } | {} {
    return {};
  }
  public buildSignedUrl(path: string, search?: HttpParams): string | null {
    return null;
  }
  public abstract provideIdentityHeaders(): IdentityHeaders;
}

export interface HttpRequestDataProvider extends ClassProvider {
  provide: typeof HttpRequestData;
}
